import { Accordion, styled } from '@mui/material';

export const Container = styled('div')(() => ({
  gap: '1rem',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

export const NoTasks = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '0.75rem',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '160%',
  color: theme.palette.grey[600],
}));

export const StyledAccordion = styled(Accordion)(() => ({
  margin: '0 !important',
  width: '100%',
  boxShadow: 'none',

  '&::before': {
    opacity: 0,
  },

  '& .MuiAccordionSummary-root': {
    minHeight: '0 !important',
    paddingLeft: '0 !important',
    paddingRight: '0 !important',

    '& .MuiAccordionSummary-content': {
      margin: '0 !important',
    },
  },

  '& .MuiAccordionDetails-root': {
    paddingLeft: '0 !important',
    paddingRight: '0 !important',
  },
}));
